import { useEffect, useRef, useState, useCallback } from "react";
import {
  MetrixEvents,
  WebengageGeneralButtonEvent,
} from "containers/services/events.data";
import { useAppContext } from "utils/context";
import { useDispatch } from "react-redux";
import { setReferral } from "store/router/action";
import { useLocation } from "react-router-dom";
import { handleUrlException } from "./services/data.transformers";
import { getWebengageWhitelist } from "./services/service";
import AndroidAlert from "components/androidAlert";
import Cookies from "js-cookie";
import AuthService from "utils/authService";
import Banner from "./components/banner";
import Content from "./components/content";
import AddToHome from "./components/addToHome";

const Login = () => {
  const dispatch = useDispatch();
  const { metrixInstance } = useAppContext();
  const [loading, setLoading] = useState(false);
  const modalRef = useRef();
  const location = useLocation();
  const params = new URLSearchParams(location?.search);

  const handleReferral = () => {
    !Cookies.get("referral_modal") &&
      Cookies.set(
        "referral_modal",
        params.get("referral_code") ? "false" : "true"
      );
  };

  const handlelogin = () => {
    setLoading(true);
    AuthService.login();
    MetrixEvents(metrixInstance, "ouywp");
    WebengageGeneralButtonEvent("login-button-pre-login", "", "button");
    dispatch(setReferral(params.get("referral_code")));
    handleReferral();
  };

  const webengageWhiteList = useCallback(async () => {
    const response = await getWebengageWhitelist();
    if (response) {
      Cookies.set("webengageEvents", JSON.stringify(response));
    }
  }, []);

  useEffect(() => {
    webengageWhiteList();
  }, [webengageWhiteList]);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isPwa = window.matchMedia("(display-mode: standalone)").matches;
    const windowSize = window.innerWidth > 768;

    if (!isPwa && !isAndroid && !windowSize) {
      handleBeforeInstallPrompt();
    }
  }, []);

  const handleBeforeInstallPrompt = () => {
    modalRef?.current?.showModal();
  };

  const onAdToHomeScreenClick = () => {
    modalRef?.current?.hideModal();
    localStorage.setItem("confirm-app-insstalled", "false");
  };

  return (
    <div className="flex flex-col bg-gradient-to-br from-primary-0 to-primary-2 w-screen h-screen md:w-auto md:h-auto md:rounded-lg  md:fixed md:top-1/2 md:left-1/2 md:-translate-y-1/2  md:-translate-x-1/2 md:shadow-xl ">
      <Banner />
      <Content handlelogin={handlelogin} loading={loading} />
      <AddToHome modalRef={modalRef} onClick={onAdToHomeScreenClick} />
      {handleUrlException(params.get("referral_code")) && (
        <div className=" w-full max-w-xl z-50 fixed top-5">
          <AndroidAlert className="alert-in-login" />
        </div>
      )}
    </div>
  );
};
export default Login;
